<template>
  <div>
    <ul v-if="errors && errors.length">
      <li
        v-for="(error, i) in errors"
        :key=i
      >
      {{error.message}}
      </li>
    </ul>
    <v-layout justify-center>
      <v-flex xs12 lg10 xl8>
        <v-expansion-panel
          expand
          dark
          class="title"
        >
          <v-expansion-panel-content class="primary">
            <div slot="header">
              Dataset Filters
            </div>
            <v-card color="grey lighten-2">
              <v-card-text>
                <v-layout row wrap justify-space-around>
                  <v-flex xs12 md5>
                    <v-text-field
                      background-color="grey lighten-2"
                      v-model="selectedText"
                      solo
                      single-line
                      light
                      label="Title Search"
                      data-cy="filter-text">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-autocomplete
                      background-color="grey lighten-2"
                      v-model="selectedPIs"
                      :items="allPIs"
                      solo
                      chips
                      deletable-chips
                      light
                      label="PI"
                      item-text="full_name"
                      item-value="email_address"
                      multiple
                      data-cy="filter-pi-select"
                      ref="filter-pi-select">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-select
                      background-color="grey lighten-2"
                      v-model="selectedDataFormats"
                      :items="allDataFormats"
                      solo
                      chips
                      light
                      label="Data Formats"
                      item-text="data_format_cd"
                      item-value="data_format_cd"
                      multiple
                      data-cy="filter-data-format-select"
                      ref="filter-data-format-select">
                    </v-select>
                  </v-flex>

                  <v-flex xs12 md5>
                    <v-select
                      background-color="grey lighten-2"
                      v-model="selectedClassifications"
                      :items="allClassifications"
                      solo
                      chips
                      light
                      label="Classifications"
                      item-text="classification_desc"
                      item-value="classification_cd"
                      multiple
                      data-cy="filter-classification-select"
                      ref="filter-classification-select">
                    </v-select>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-radio-group
                      label="Creation Date:"
                      v-model="selectedCreateDate"
                      value="All"
                      light
                      data-cy="filter-createdate-radio"
                    >
                      <v-radio
                        label="All"
                        light
                        value="All"
                      >
                      </v-radio>
                      <v-radio
                        label="Last Quarter"
                        light
                        value="true"
                      >
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-radio-group
                      label="Status:"
                      v-model="selectedDatasetStatus"
                      value="All"
                      light
                      data-cy="filter-status-radio"
                    >
                      <v-radio
                        label="All"
                        light
                        value="All">
                      </v-radio>
                      <v-radio
                        label="Complete"
                        light
                        value="false">
                      </v-radio>
                      <v-radio
                        label="In Progress"
                        light
                        value="true">
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  @click="clearFilters()"
                  data-cy="clear-filters"
                >
                  Clear Filters
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      <v-divider></v-divider>

      <v-layout justify-space-between>
        <v-flex xs6>
          <v-card
            tile
            color="primary white--text"
            height="100%"
          >
            <v-card-title class="title">
              Dataset Stats
            </v-card-title>
            <v-card-text>
              <v-flex xs12 lg8 xl6>
               <v-list class="primary white--text">
                  <v-list-tile>
                    <v-list-tile-content>Dataset</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ countFilteredDatasets }} of {{ countAllDatasets }}
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>Completed</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ countFilteredCompletedDatasets }} of {{ countAllCompletedDatasets }}
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>In Progress</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      {{ countFilteredInProgressDatasets }} of {{ countAllInProgressDatasets }}
                    </v-list-tile-content>
                  </v-list-tile>
               </v-list>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-flex xs6>
          <v-card
            tile
            color="primary white--text"
            height="100%">
            <v-card-title class="title">
              Dataset Information
            </v-card-title>
            <v-card-text>
              <v-layout row wrap text-lg-left>
                  Data Garage is an Mcity maintained dataset catalog. We aggregate meta-data about datasets that are produced by Mcity, Mcity members, UM Faculty/Staff, and the industry for search into Data Garage.
                  Using the filters above you can locate information about specific datasets which are available to you.
                  <br><br>
                  If you find a dataset that is missing, please email mcity-engineering@umich.edu so that we may include it here in the future.
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-space-around>
        <v-flex xs12 md5
          v-for="(dataset, index) in selectedDatasets"
          :key="index"
        >
          <v-card
            @click.native="openDataset(dataset)"
            class="my-3 grow"
            role="button"
            data-cy="dataset-card"
          >
            <v-card-title class="headline primary white--text">
                {{ dataset.dataset_name }}
            </v-card-title>
            <v-card-text class="text-xs-left">
              <b>Classifications(s):</b>
                <div
                  v-for="(classification) in dataset.classification"
                  :key="classification.key"
                  class="pl-2"
                >
                  {{ classification.classification_desc }}
                </div>
              <b>Data Format(s):</b>
              <div>
                <div
                  v-for="(dataformat) in dataset.data_format"
                  :key="dataformat.key"
                  class="pl-2"
                >
                  {{ dataformat.data_format_cd }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
     </v-flex>
    </v-layout>
  </div>
</template>

<script>
import isSameQuarter from 'date-fns/is_same_quarter'
import pipe from 'ramda/src/pipe'
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      errors: [],
      activeTab: null,
      filterDefaults: {
        selectedDatasetStatus: 'All',
        selectedClassifications: [],
        selectedDataFormats: [],
        selectedText: '',
        selectedCreateDate: 'All',
        selectedPIs: []
      }
    }
  },
  computed: {
    ...mapState({
      allDataFormats: state => state.dataset.transactions.allDataFormats,
      allClassifications: state => state.dataset.transactions.allClassifications,
      allPIs: state => state.dataset.transactions.allPIs,
      allDatasets: state => state.dataset.transactions.allDatasets
    }),
    selectedDatasetStatus: {
      get () {
        return this.$store.state.filters.selectedDatasetStatus
      },
      set (val) {
        this.setDatasetStatusFilter(val)
      },
    },
    selectedCreateDate: {
      get () {
        return this.$store.state.filters.selectedCreateDate
      },
      set (val) {
        this.setCreateDateFilter(val)
      },
    },
    selectedDataFormats: {
      get () {
        return this.$store.state.filters.selectedDataFormats
      },
      set (val) {
        this.setDataFormatFilter(val)
      },
    },
    selectedClassifications: {
      get () {
        return this.$store.state.filters.selectedClassifications
      },
      set (val) {
        this.setClassificationFilter(val)
      },
    },
    selectedPIs: {
      get () {
        return this.$store.state.filters.selectedPIs
      },
      set (val) {
        this.setPIFilter(val)
      },
    },
    selectedText: {
      get () {
        return this.$store.state.filters.selectedText
      },
      set (val) {
        this.setTextFilter(val)
      },
    },
    selectedDatasets () {
      return pipe(
          this.filterForDataFormat,
          this.filterForClassification,
          this.filterForPI,
          this.filterForDatasetStatus,
          this.filterForRecentCreate,
          this.filterForDatasetName
        )(this.allDatasets)
    },
    countAllDatasets () {
      return this.allDatasets ? this.allDatasets.length : 0
    },
    countFilteredDatasets () {
      return this.selectedDatasets ? this.selectedDatasets.length : 0
    },
    countFilteredInProgressDatasets () {
      return this.selectedDatasets ? this.selectedDatasets.filter(list => (list.in_progress === true)).length : 0
    },
    countAllInProgressDatasets () {
      return this.allDatasets ? this.allDatasets.filter(list => (list.in_progress === true)).length : 0
    },
    countFilteredCompletedDatasets () {
      return this.selectedDatasets ? this.selectedDatasets.filter(list => (list.in_progress === false)).length : 0
    },
    countAllCompletedDatasets () {
      return this.allDatasets ? this.allDatasets.filter(list => (list.in_progress === false)).length : 0
    }
  },
  methods: {
     ...mapMutations([
      'setPIFilter',
      'setClassificationFilter',
      'setDataFormatFilter',
      'setTextFilter',
      'setCreateDateFilter',
      'setDatasetStatusFilter'

    ]),
     ...mapActions([
      'fetchAllPIsAction',
      'fetchAllClassificationsAction',
      'fetchAllDataFormatsAction',
      'fetchAllDatasetsAction'
    ]),
    openDataset (dataset) {
      this.$router.push({name: 'Dataset', params: {key: dataset.dataset_key}})
    },
    filterForDataFormat (arg) {
      if (this.selectedDataFormats.length > 0) {
        return arg.filter(list => list.data_format.some(r => this.selectedDataFormats.indexOf(r.data_format_cd) >= 0))
      } else {
        return arg
      }
    },
    filterForClassification (arg) {
      if (this.selectedClassifications.length > 0) {
        return arg.filter(list => list.classification.some(r => this.selectedClassifications.indexOf(r.classification_cd) >= 0))
      } else {
        return arg
      }
    },
    filterForDatasetName (arg) {
      if (this.selectedText.length > 0) {
        return arg.filter(list => list.dataset_name.toLowerCase().includes(this.selectedText.toLowerCase()))
      } else {
        return arg
      }
    },
    filterForRecentCreate (arg) {
      if (this.selectedCreateDate === 'true') {
        let today = new Date()
        return arg.filter(list => isSameQuarter(list.create_date, today))
      } else {
        return arg
      }
    },
    filterForPI (arg) {
      if (this.selectedPIs.length > 0) {
        return arg.filter(list => list.dataset_pi.some(r => this.selectedPIs.indexOf(r.email_address) >= 0))
      } else {
        return arg
      }
    },
    filterForDatasetStatus (arg) {
      if (this.selectedDatasetStatus === 'true') {
        return arg.filter(list => (list.in_progress === true))
      } else if (this.selectedDatasetStatus === 'false') {
        return arg.filter(list => (list.in_progress === false))
      } else {
        return arg
      }
    },
    clearFilters () {
      this.selectedDataFormats = []
      this.selectedClassifications = []
      this.selectedPIs = []
      this.selectedCreateDate = 'All'
      this.selectedText = ''
      this.selectedDatasetStatus = 'All'
      this.$refs['filter-data-format-select'].isMenuActive = false
      this.$refs['filter-classification-select'].isMenuActive = false
      this.$refs['filter-pi-select'].isMenuActive = false
    }
  },
  mounted () {
    this.fetchAllDatasetsAction()
    this.fetchAllPIsAction()
    this.fetchAllClassificationsAction()
    this.fetchAllDataFormatsAction()
  }
}
</script>

<style>
  ul {
    list-style: none;
  }
  .grow {
    transition: transform .2s ease-in-out;
  }
  .grow:hover {
    transform: scale(1.06);
    -ms-transform: scale(1.06);
    -webkit-transform: scale(1.06);
  }
</style>
